import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  priceTierList: [
    { value: 0, label: 'NON-G1' },
    { value: 1, label: 'G1' }
  ],
  settings: {
    remainingStickers: 0,
    reOrderStatus: null,
    reOrderThreshold: 0,
    nextShipDate: null,
    reOrderId: null,
    dealerId: null,
    skipNextAutoOrder: false,
    stickerType: 0
  },
  RE_ORDER_STATUS: {
    CANCELED: 0,
    ACTIVE: 1,
    PAUSED: 2,
    INACTIVE: 3
  },
  ORDER_TYPE: {
    MANUAL: 0,
    AUTO: 1
  },
  dealerInfo: {},
  defaultOrderItems: {},
  orderHistory: [],
  showReOrderCancelledModal: false,
  showReOrderActivateModal: false,
  showOrderPlacedModal: true,
  latestOrder: null,
  defaultOrder: null,
  draftOrders: {}
};

const windowStickerSlice = createSlice({
  name: 'ws',
  initialState,
  reducers: {
    handleAddProducts: (state, action) => {
      state.products = action.payload;
    },
    handleDeleteProduct: (state, action) => {
      const productId = action.payload;
      const index = state.products.findIndex(item => item.wsp_id === productId);
      state.products[index].wsp_is_delete = 1;
    },
    handleAddNewProduct: (state, action) => {
      state.products = [...state.products, action.payload];
    },
    handleUpdateSetting: (state, action) => {
      state.defaultOrderItems = {}; // reset default order items when settings are updated
      state.settings.reOrderStatus = action.payload.wsos_re_order_status;
      state.settings.reOrderThreshold = action.payload.wsos_re_order_threshold;
      state.settings.remainingStickers = action.payload.wsos_remaining_stickers;
      state.settings.dealerId = action.payload.wsos_dealer_id;
      state.settings.nextShipDate = action.payload?.wsos_next_ship_date || null;
      state.settings.reOrderId = action.payload?.wsos_re_order_id || null;
      state.settings.skipNextAutoOrder = action.payload?.wsos_skip_next_order || false;
      state.settings.stickerType = action.payload?.wsos_sticker_type || 0;
    },
    handleUpdateSticker: (state, action) => {
      state.settings.remainingStickers = action.payload;
    },
    handleUpdateThreshold: (state, action) => {
      state.settings.reOrderThreshold = Number(action.payload);
    },
    handleUpdateReorderStatus: (state, action) => {
      state.settings.reOrderStatus = action.payload;
    },
    handleUpdateShipDate: (state, action) => {
      state.settings.nextShipDate = action.payload;
    },
    handleUpdateDealerInfo: (state, action) => {
      state.dealerInfo = action.payload;
    },
    handleUpdateDefaultOrderItems: (state, action) => {
      state.defaultOrderItems = action.payload; // save the order items to show in default set modal
    },
    handleUpdateOrderHistory: (state, action) => {
      state.orderHistory = action.payload; // replace the entire order history
    },
    handleAddNewOrderHistory: (state, action) => {
      state.orderHistory = [action.payload, ...state.orderHistory]; // add new order to the top of the history
      state.latestOrder = action.payload; // save the latest order to show in order placed modal
      state.showOrderPlacedModal = true; // show the order placed modal
    },
    handleShowReOrderCancelledModal: (state, action) => {
      state.showReOrderCancelledModal = action.payload;
    },
    handleShowReOrderActivateModal: (state, action) => {
      state.showReOrderActivateModal = action.payload;
    },
    handleShowOrderPlacedModal: (state, action) => {
      state.showOrderPlacedModal = action.payload;
    },
    handleUpdateDefaultOrder: (state, action) => {
      state.defaultOrder = action.payload;
    },
    handleAddDraftOrder: (state, action) => {
      const { dealerId, orderItems } = action.payload;
      state.draftOrders = { ...state.draftOrders, [dealerId]: orderItems };
    },
    handleRemoveDraftOrder: (state, action) => {
      if (state.draftOrders[action.payload]) {
        delete state.draftOrders[action.payload];
      }
    }
  }
});

export const {
  handleAddProducts,
  handleDeleteProduct,
  handleAddNewProduct,
  handleUpdateSetting,
  handleUpdateSticker,
  handleUpdateThreshold,
  handleUpdateReorderStatus,
  handleUpdateShipDate,
  handleUpdateDealerInfo,
  handleUpdateDefaultOrderItems,
  handleUpdateOrderHistory,
  handleAddNewOrderHistory,
  handleShowReOrderCancelledModal,
  handleShowReOrderActivateModal,
  handleShowOrderPlacedModal,
  handleUpdateDefaultOrder,
  handleAddDraftOrder,
  handleRemoveDraftOrder
} = windowStickerSlice.actions;

export default windowStickerSlice.reducer;
